export default __webpack_public_path__ + "static/media/box.1b039f7d.svg";